import React, { useState } from 'react';
import { ActivePowerHeatmap } from '../components/PowerHeatmap';

const PowerHeatmap: React.FC = () => {
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().split('T')[0]
  );
  const [selectedPlant, setSelectedPlant] = useState('Torrent Saurya Urja 05');

  return (
    <div className="p-6 space-y-6">
      {/* Header */}
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">
            Inverters Active Power Heatmap
          </h1>
          <p className="text-gray-600 mt-1">
            Real-time power distribution and fault detection across inverters
          </p>
        </div>
      </div>

      {/* Filters */}
      <div className="bg-white p-4 rounded-lg shadow-sm border">
        <div className="flex items-center space-x-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Date
            </label>
            <input
              type="date"
              value={selectedDate}
              onChange={(e) => setSelectedDate(e.target.value)}
              className="border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Plant
            </label>
            <select
              value={selectedPlant}
              onChange={(e) => setSelectedPlant(e.target.value)}
              className="border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="Torrent Saurya Urja 05">Torrent Saurya Urja 05</option>
              <option value="GHCL 10 MW">GHCL 10 MW</option>
              <option value="Pollax 16 MW">Pollax 16 MW</option>
            </select>
          </div>
        </div>
      </div>

      {/* Heatmap */}
      <div className="bg-white p-6 rounded-lg shadow-sm border">
        <ActivePowerHeatmap 
          date={selectedDate}
          plantId={selectedPlant}
        />
      </div>

      {/* Intelligence Insights */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="bg-white p-6 rounded-lg shadow-sm border">
          <h3 className="text-lg font-semibold mb-4">Performance Insights</h3>
          <div className="space-y-3">
            <div className="flex items-center space-x-2">
              <div className="w-3 h-3 bg-green-500 rounded-full"></div>
              <span className="text-sm">High performing inverters clustered in blocks 1-3</span>
            </div>
            <div className="flex items-center space-x-2">
              <div className="w-3 h-3 bg-yellow-500 rounded-full"></div>
              <span className="text-sm">Block 5 showing reduced output - investigate</span>
            </div>
            <div className="flex items-center space-x-2">
              <div className="w-3 h-3 bg-red-500 rounded-full"></div>
              <span className="text-sm">INV-12 in Block 4 requires immediate attention</span>
            </div>
          </div>
        </div>

        <div className="bg-white p-6 rounded-lg shadow-sm border">
          <h3 className="text-lg font-semibold mb-4">Fault Detection</h3>
          <div className="space-y-3">
            <div className="text-sm text-gray-600">
              <span className="font-medium">Power Drop Detector:</span> 2 inverters with sudden drops
            </div>
            <div className="text-sm text-gray-600">
              <span className="font-medium">Grid Sync Status:</span> All inverters synchronized
            </div>
            <div className="text-sm text-gray-600">
              <span className="font-medium">Predictive Index:</span> 95% operational confidence
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PowerHeatmap;